import React from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import { Link } from "react-router-dom";
import { useI18n } from "../i18n";

function History() {
  const { t } = useI18n();

  return (

    <>
      <>
        <Header />
        <>
          {/* Page Header Section Start */}
          <div className="page-header bg-section parallaxie">
            <div className="container">
              <div className="row">
                <div className="col-lg-12">
                  {/* Page Header Box Start */}
                  <div className="page-header-box">
                    <h1 className="text-anime-style-3" data-cursor="-opaque">{t('pages.historyTitle')}</h1>

                  </div>
                  {/* Page Header Box End */}
                </div>
              </div>
            </div>
          </div>
          {/* Page Header Section End */}
          {/* Featival Vibes Section Start */}
          <div className="festival-vibes">
                        <div className="container">
                            <div className="row align-items-center">
                                <div className="col-lg-6">
                                    {/* Festival Vibes Content Start */}
                                    <div className="festival-vibes-content">
                                        {/* Section Title Start */}
                                        <div className="section-title">
                                            <h3 className="wow fadeInUp">{t('pages.historyH3')}</h3>
                                            <h2 className="text-anime-style-3" data-cursor="-opaque">{t('pages.historyH2')}</h2>
                                            <p className="wow fadeInUp" data-wow-delay="0.2s">{t('pages.historyIntroP')}</p>
                                        </div>
                                        {/* Section Title End */}
                                        {/* Festival Vibes Button Start */}
                                        <div
                                            className="festival-vibes-btn wow fadeInUp"
                                            data-wow-delay="0.4s"
                                        >
                                            <Link to="/Contact" className="btn-default"> {t('pages.historyBtn')}</Link>
                                        </div>
                                        {/* Festival Vibes Button End */}
                                        {/* Festival vibes Body Start */}
                                        <div
                                            className="festival-vibes-body wow fadeInUp"
                                            data-wow-delay="0.6s"
                                        >
                                            <div className="festival-vibes-body-list">
                                                <ul>
                                                    <li>{t('pages.historyList1')}</li>
                                                    <li>{t('pages.historyList2')}</li>
                                                    <li>{t('pages.historyList3')}</li>
                                                    <li>{t('pages.historyList4')}</li>
                                                </ul>
                                            </div>
                                            <div className="festival-vibes-body-item">
                                                <div className="festival-vibes-body-img">
                                                    <figure className="image-anime">
                                                        <img src="images/Untitled design (26).png" alt="" />
                                                    </figure>
                                                </div>

                                            </div>
                                        </div>
                                        {/* Festival vibes Body End */}
                                    </div>
                                    {/* Festival Vibes Content End */}
                                </div>
                                <div className="col-lg-6">
                                    {/* Festival Vibes Image Start */}
                                    <div className="festival-vibes-image">
                                        <figure className="image-anime ">
                                            <img src="images/Untitled design (28).png" alt="" />
                                        </figure>
                                    </div>
                                    {/* Festival Vibes Image End */}
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Featival Vibes Section End */}

        </>

        <Footer />
      </>

    </>
  );
}

export default History;